/**
 *  Available numeric filters
 *
 */
export type RdsNumericOperation = '>' | '>=' | '=' | '!=' | '<' | '<=';

export function invertNumericOperation(operation: RdsNumericOperation): RdsNumericOperation {
  switch (operation) {
    case '>':
      return '<';
    case '>=':
      return '<=';
    case '=':
      return '!=';
    case '!=':
      return '=';
    case '<':
      return '>';
    case '<=':
      return '>=';
  }
}

export class RdsNumericOperationOption {
  constructor(public label: string, public type: RdsNumericOperation) {}
}

export const RDS_NUMERIC_OPERATION_OPTIONS: ReadonlyArray<RdsNumericOperationOption> = Object.freeze([
  new RdsNumericOperationOption('Greater than', '>'),
  new RdsNumericOperationOption('Greater than or Equal to', '>='),
  new RdsNumericOperationOption('Equal to', '='),
  new RdsNumericOperationOption('Not Equal to', '!='),
  new RdsNumericOperationOption('Less than', '<'),
  new RdsNumericOperationOption('Less than or Equal to', '<=')
]);

/**
 * RDS Numeric Filter
 */
export class RdsNumericFilter {
  /**
   * Creates an instance of RdsNumericFilter
   * @param value number input
   * @param operation text of selected operation
   */
  constructor(public value: number, public operation: RdsNumericOperationOption) {}
}

export function instanceOfRdsNumericFilter(obj: any): obj is RdsNumericFilter {
  return 'value' in obj && 'operation' in obj;
}
